import { axiosInstance } from "../../../Utils/AxiosInstance";

export const GetPurchaseOrderByIdAction = (data) => ({
  type: "get_purchaseorder_byid",
  data,
  loader: false,
});

export function getPurchaseOrderById(id) {
  return async (dispatch) => {
    dispatch({ type: "get_purchaseorder_byid", data: null, loader: true });
    try {
      const res = await axiosInstance.get(`/PurchaseOrders/GetById/${id}`);
      dispatch(GetPurchaseOrderByIdAction(res.data));
      return res;
    } catch (error) {
      dispatch(GetPurchaseOrderByIdAction(null));
      return { ...error?.response };
    }
  };
}
